"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Matrix = void 0;
const react_1 = __importDefault(require("react"));
const getValueAllSelectedCells_1 = require("./helpers/getValueAllSelectedCells");
const Matrix_styles_1 = require("./Matrix.styles");
const constants_1 = require("../../helpers/constants");
const Button_1 = require("../../../Button");
const Icon_1 = require("../../../Icon");
const icons_1 = require("../../../icons");
const lib_for_Matrix_1 = require("../../lib-for-Matrix");
const types_1 = require("../../types");
const getRenderDescriptionOverLeftTopCaptionCell = () => (react_1.default.createElement(Matrix_styles_1.StyledMatrixRow, null,
    react_1.default.createElement(Matrix_styles_1.StyledMatrixMatrixCell, { isDayCaption: true, iconType: types_1.CELL_ICON_TYPE.moon })));
const getRenderDescriptionOverMainCells = () => (react_1.default.createElement(Matrix_styles_1.StyledMatrixRow, null,
    react_1.default.createElement(Matrix_styles_1.StyledMatrixMatrixCell, { isLong: true, iconType: types_1.CELL_ICON_TYPE.sun, text: "AM" }),
    react_1.default.createElement(Matrix_styles_1.StyledMatrixMatrixCell, { isLong: true, iconType: types_1.CELL_ICON_TYPE.moon, text: "PM" })));
const getRenderSelectOptionCaptionCell = () => (react_1.default.createElement(Matrix_styles_1.StyledMatrixSelectOptionRow, null,
    react_1.default.createElement(Matrix_styles_1.StyledMatrixMatrixCell, { indexHour: -1, indexDay: -2, isDayCaption: true, text: "Select:" })));
const getRenderTimeOptionCaptionCell = () => (react_1.default.createElement(Matrix_styles_1.StyledMatrixTimeOptionRow, null,
    react_1.default.createElement(Matrix_styles_1.StyledMatrixMatrixCell, { indexHour: -1, indexDay: -3, isDayCaption: true })));
exports.Matrix = class extends react_1.default.Component {
    constructor(props) {
        super(props);
        const { format = types_1.BACKUP_MATRIX_FORMAT.eu, selectedCells = (0, getValueAllSelectedCells_1.getValueAllSelectedCells)(), time = 0, isSelectMode = false, cursor = {
            event: types_1.CURSOR_EVENT.null
        } } = this.props;
        this.format = format;
        this.hasDataCursor = (cursor === null || cursor === void 0 ? void 0 : cursor.event) !== types_1.CURSOR_EVENT.null;
        this.dataSelectorId = this.props['data-selector-id'] || 'matrix';
        this.onCellMouseDown = this.onCellMouseDown.bind(this);
        this.onCellMouseOver = this.onCellMouseOver.bind(this);
        this.onCellMouseUp = this.onCellMouseUp.bind(this);
        this.onChangeSelectMode = this.onChangeSelectMode.bind(this);
        this.onChangeStartTime = this.onChangeStartTime.bind(this);
        this.onSelectAllCell = this.onSelectAllCell.bind(this);
        this.onUnSelectAllCell = this.onUnSelectAllCell.bind(this);
        this.getRenderLeftTopCaptionCell = this.getRenderLeftTopCaptionCell.bind(this);
        this.getRenderDayCaptionCell = this.getRenderDayCaptionCell.bind(this);
        this.getRenderAllDayCaptionCells = this.getRenderAllDayCaptionCells.bind(this);
        this.getRenderAllHourCaptionCells = this.getRenderAllHourCaptionCells.bind(this);
        this.getRenderMainCell = this.getRenderMainCell.bind(this);
        this.getRenderAllMainCells = this.getRenderAllMainCells.bind(this);
        this.getRenderSelectOptionElements = this.getRenderSelectOptionElements.bind(this);
        this.getRenderTimeOptionElements = this.getRenderTimeOptionElements.bind(this);
        this.getCellDataForDrawBackground = this.getCellDataForDrawBackground.bind(this);
        this.getDataOfSelectElements = this.getDataOfSelectElements.bind(this);
        this.getDataOfHoverElement = this.getDataOfHoverElement.bind(this);
        this.parseAndUpdateState = this.parseAndUpdateState.bind(this);
        this.callPropsOnChange = this.callPropsOnChange.bind(this);
        this.state = {
            selectedCells,
            valueTime: time,
            tmpSelectedCells: {},
            tmpActiveFirstSelectedCell: {},
            cellStatusInfo: null,
            startPosition: {},
            endPosition: {},
            hoverPosition: {},
            isSelectMode,
            isSelectedDay: false,
            isSelectedHour: false,
            isActive: false,
            cursor: {
                event: types_1.CURSOR_EVENT.onMouseMove
            }
        };
        this.domNodeRef = react_1.default.createRef();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { disabled, cursor, resetEvent } = nextProps;
        const cursorX = cursor ? cursor.x : undefined;
        const cursorY = cursor ? cursor.y : undefined;
        const event = cursor ? cursor.event : types_1.CURSOR_EVENT.null;
        if (!disabled && this.hasDataCursor && cursorX && cursorY) {
            const { tmpSelectedCells, isActive, startPosition: oldStartPosition, endPosition: { indexHour: oldStateEndPositionHour, indexDay: oldStateEndPositionDay } } = this.state;
            const { newIndexHour, newIndexDay, isOverCell } = (0, lib_for_Matrix_1.getCellMainDataOfCursor)(this.domNodeRef, this.format, oldStartPosition, { cursorX, cursorY });
            if (newIndexHour != null && newIndexDay != null) {
                switch (event) {
                    case types_1.CURSOR_EVENT.onMouseDown:
                        this.onCellMouseDown(newIndexHour, newIndexDay);
                        resetEvent === null || resetEvent === void 0 ? void 0 : resetEvent();
                        break;
                    case types_1.CURSOR_EVENT.onMouseUp:
                        this.onCellMouseUp(newIndexHour, newIndexDay);
                        resetEvent === null || resetEvent === void 0 ? void 0 : resetEvent();
                        break;
                    default:
                        // is CURSOR_EVENT.onMouseMove
                        this.onCellMouseOver(newIndexHour, newIndexDay);
                }
            }
            else if (event === types_1.CURSOR_EVENT.onMouseUp) {
                if (oldStateEndPositionHour != null && oldStateEndPositionDay != null) {
                    this.onCellMouseUp(oldStateEndPositionHour, oldStateEndPositionDay);
                    resetEvent === null || resetEvent === void 0 ? void 0 : resetEvent();
                }
            }
            else if (!isOverCell && !isActive && Object.keys(tmpSelectedCells).length > 0) {
                // is outside Matrix on passive mode
                this.setState({
                    tmpSelectedCells: {}
                });
            }
        }
    }
    onCellMouseDown(indexHour, indexDay) {
        if (!this.hasDataCursor &&
            this.state.startPosition.indexHour &&
            this.state.startPosition.indexDay &&
            this.state.endPosition.indexHour &&
            this.state.endPosition.indexDay) {
            // for fix onMouseDown
            const currState = Object.assign(Object.assign({}, this.state), { startPosition: {
                    indexHour: this.state.startPosition.indexHour,
                    indexDay: this.state.startPosition.indexDay
                }, endPosition: {
                    indexHour: this.state.endPosition.indexHour,
                    indexDay: this.state.endPosition.indexDay
                } });
            this.parseAndUpdateState(false, currState);
        }
        else {
            const startPosition = { indexHour, indexDay };
            this.parseAndUpdateState(true, Object.assign(Object.assign({}, this.state), { startPosition, endPosition: startPosition, isSelectedHour: indexDay === -1, isSelectedDay: indexHour === -1, isActive: true }));
        }
    }
    onCellMouseOver(indexHour, indexDay) {
        const hoverPosition = { indexHour, indexDay };
        let endIndexHourTMP = indexHour;
        let endIndexDayTMP = indexDay;
        if (this.state.startPosition.indexHour !== undefined &&
            this.state.startPosition.indexDay !== undefined &&
            (this.state.startPosition.indexHour === -1 ||
                this.state.startPosition.indexDay === -1 ||
                (this.state.startPosition.indexHour > -1 && this.state.startPosition.indexDay > -1))) {
            const currState = Object.assign(Object.assign({}, this.state), { startPosition: {
                    indexHour: this.state.startPosition.indexHour,
                    indexDay: this.state.startPosition.indexDay
                } });
            const { indexHour: startPositionIndexHour, indexDay: startPositionIndexDay } = this.state.startPosition;
            if (startPositionIndexHour > -1 && indexHour < 0) {
                // for cancel select all hours
                endIndexHourTMP = 0;
            }
            if (startPositionIndexDay > -1 && indexDay < 0) {
                // for correct select cells when cursor over hour caption
                endIndexDayTMP = constants_1.DISPLAY_CONFIG_VARIANTS[this.format].dayStartIndex;
            }
            this.parseAndUpdateState(true, Object.assign(Object.assign({}, currState), { endPosition: {
                    indexHour: endIndexHourTMP,
                    indexDay: endIndexDayTMP
                }, hoverPosition }));
        }
        else {
            this.parseAndUpdateState(true, Object.assign(Object.assign({}, this.state), { tmpSelectedCells: {}, startPosition: {}, hoverPosition, isSelectedHour: false, isSelectedDay: false }));
        }
    }
    onCellMouseUp(indexHour, indexDay) {
        this.parseAndUpdateState(false, Object.assign(Object.assign({}, this.state), { endPosition: { indexHour, indexDay }, isActive: false }));
    }
    onChangeSelectMode(value) {
        this.setState({
            isSelectMode: value === types_1.SELECT_MODE.permitted,
            tmpSelectedCells: {},
            tmpActiveFirstSelectedCell: {}
        });
    }
    onChangeStartTime(valueTime) {
        // value time changed by NumberField
        this.setState({
            valueTime
        }, this.callPropsOnChange);
    }
    onSelectAllCell() {
        this.setState({
            selectedCells: (0, getValueAllSelectedCells_1.getValueAllSelectedCells)(),
            tmpSelectedCells: {},
            tmpActiveFirstSelectedCell: {}
        }, this.callPropsOnChange);
    }
    onUnSelectAllCell() {
        this.setState({
            selectedCells: {},
            tmpSelectedCells: {},
            tmpActiveFirstSelectedCell: {}
        }, this.callPropsOnChange);
    }
    getRenderLeftTopCaptionCell() {
        // It's cell at the intersection of captions of the day and hours
        return (react_1.default.createElement(Matrix_styles_1.StyledMatrixRow, null,
            react_1.default.createElement(Matrix_styles_1.StyledMatrixMatrixCell, { indexHour: -1, indexDay: -1, text: constants_1.DISPLAY_CONFIG_VARIANTS[this.format].hours[0] })));
    }
    getRenderAllHourCaptionCells() {
        const { tmpActiveFirstSelectedCell: { indexHour: tmpActiveFirstSelectedCellIndexHour, indexDay: tmpActiveFirstSelectedCellIndexDay, status: tmpActiveFirstSelectedCellStatus } } = this.state;
        return (react_1.default.createElement(Matrix_styles_1.StyledMatrixRow, null, constants_1.DISPLAY_EU_HOURS.slice(1).map((displayHour) => {
            const showHour = constants_1.DISPLAY_CONFIG_VARIANTS[this.format].hours[displayHour];
            const indexHour = displayHour - 1;
            const { isDrawnLink, status } = this.getCellDataForDrawBackground(indexHour, -1, tmpActiveFirstSelectedCellIndexHour === indexHour &&
                tmpActiveFirstSelectedCellIndexDay === -1
                ? tmpActiveFirstSelectedCellStatus
                : null);
            // hour caption cell
            return (react_1.default.createElement(Matrix_styles_1.StyledMatrixMatrixCell, { key: `matrix-cell-hour-caption-${indexHour}--1`, indexHour: indexHour, indexDay: -1, text: showHour, isDrawnLink: isDrawnLink, status: status }));
        })));
    }
    getRenderDayCaptionCell(indexDay) {
        const { tmpActiveFirstSelectedCell: { indexHour: tmpActiveFirstSelectedCellIndexHour, indexDay: tmpActiveFirstSelectedCellIndexDay, status: tmpActiveFirstSelectedCellStatus } } = this.state;
        const { isDrawnLink, status } = this.getCellDataForDrawBackground(-1, indexDay, tmpActiveFirstSelectedCellIndexHour === -1 &&
            tmpActiveFirstSelectedCellIndexDay === indexDay
            ? tmpActiveFirstSelectedCellStatus
            : null);
        return (react_1.default.createElement(Matrix_styles_1.StyledMatrixRow, { key: `matrix-row-day-caption--1-${indexDay}` },
            react_1.default.createElement(Matrix_styles_1.StyledMatrixMatrixCell, { key: `matrix-cell-day-caption--1-${indexDay}`, indexHour: -1, indexDay: indexDay, isDayCaption: true, text: constants_1.DAYS[indexDay], isDrawnLink: isDrawnLink, status: status })));
    }
    getRenderAllDayCaptionCells() {
        let rows = [];
        if (this.format === types_1.BACKUP_MATRIX_FORMAT.us) {
            rows.push(this.getRenderDayCaptionCell(constants_1.DISPLAY_CONFIG_VARIANTS[this.format].dayStartIndex));
        }
        rows = constants_1.DAYS.reduce((renderDayCaptionCell, currentRows, indexDay) => this.format === types_1.BACKUP_MATRIX_FORMAT.us &&
            indexDay >= constants_1.DISPLAY_CONFIG_VARIANTS[this.format].dayStartIndex
            ? renderDayCaptionCell
            : renderDayCaptionCell.concat(this.getRenderDayCaptionCell(indexDay)), rows);
        return rows;
    }
    getRenderMainCell(indexDay) {
        const { tmpActiveFirstSelectedCell: { indexHour: tmpActiveFirstSelectedCellIndexHour, indexDay: tmpActiveFirstSelectedCellIndexDay, status: tmpActiveFirstSelectedCellStatus } } = this.state;
        return (react_1.default.createElement(Matrix_styles_1.StyledMatrixRow, { key: `matrix-row-cell-main-${indexDay}` }, constants_1.DISPLAY_EU_HOURS.slice(0, constants_1.DISPLAY_EU_HOURS.length - 1).map((indexHour) => {
            const { status } = this.getCellDataForDrawBackground(indexHour, indexDay, tmpActiveFirstSelectedCellIndexHour === indexHour &&
                tmpActiveFirstSelectedCellIndexDay === indexDay
                ? tmpActiveFirstSelectedCellStatus
                : null);
            return (react_1.default.createElement(Matrix_styles_1.StyledMatrixMatrixCell, { key: `matrix-cell-main-${indexHour}-${indexDay}`, indexHour: indexHour, indexDay: indexDay, status: status }));
        })));
    }
    getRenderAllMainCells() {
        let rows = [];
        if (this.format === types_1.BACKUP_MATRIX_FORMAT.us) {
            rows.push(this.getRenderMainCell(constants_1.DISPLAY_CONFIG_VARIANTS[this.format].dayStartIndex));
        }
        rows = constants_1.DAYS.reduce((renderMainCell, currentRows, indexDay) => this.format === types_1.BACKUP_MATRIX_FORMAT.us &&
            indexDay >= constants_1.DISPLAY_CONFIG_VARIANTS[this.format].dayStartIndex
            ? renderMainCell
            : renderMainCell.concat(this.getRenderMainCell(indexDay)), rows);
        return rows;
    }
    getRenderSelectOptionElements() {
        const { disabled } = this.props;
        const { isSelectMode } = this.state;
        return (react_1.default.createElement(Matrix_styles_1.StyledMatrixSelectOptionRow, null,
            react_1.default.createElement(Matrix_styles_1.StyledMatrixMatrixCell, { status: constants_1.STATUS_CELL.UNSELECTED, isDemo: true }),
            react_1.default.createElement(Matrix_styles_1.StyledMatrixRadiobutton, { value: types_1.SELECT_MODE.denied, checked: !isSelectMode, onChange: (value) => this.onChangeSelectMode(value), disabled: disabled, "data-selector-id": `${this.dataSelectorId}-denied-control` }, "Denied"),
            react_1.default.createElement(Matrix_styles_1.StyledMatrixMatrixCell, { status: constants_1.STATUS_CELL.SELECTED, isDemo: true }),
            react_1.default.createElement(Matrix_styles_1.StyledMatrixRadiobutton, { value: types_1.SELECT_MODE.permitted, checked: isSelectMode, onChange: (value) => this.onChangeSelectMode(value), disabled: disabled, "data-selector-id": `${this.dataSelectorId}-permitted-control` }, "Permitted"),
            react_1.default.createElement(Matrix_styles_1.StyledMatrixSelectOptionButtonWrapper, null,
                react_1.default.createElement(Button_1.Button, { ui: Button_1.BUTTON_VIEW.text, onClick: this.onUnSelectAllCell, disabled: disabled, "data-selector-id": `${this.dataSelectorId}-deny-all-control` },
                    react_1.default.createElement(Icon_1.Icon, { src: react_1.default.createElement(icons_1.DeniedIcon, null) }),
                    "Deny All"),
                react_1.default.createElement(Button_1.Button, { ui: Button_1.BUTTON_VIEW.text, onClick: this.onSelectAllCell, disabled: disabled, "data-selector-id": `${this.dataSelectorId}-permit-all-control` },
                    react_1.default.createElement(Icon_1.Icon, { src: react_1.default.createElement(icons_1.VerifyIcon, null) }),
                    "Permit All"))));
    }
    getRenderTimeOptionElements() {
        const { disabled, maxValue, minValue } = this.props;
        const { valueTime } = this.state;
        return (react_1.default.createElement(Matrix_styles_1.StyledMatrixTimeOptionRow, { disabled: disabled },
            "Start time within an hour:",
            react_1.default.createElement(Matrix_styles_1.StyledMatrixNumberInput, { disabled: disabled, value: valueTime, onChange: this.onChangeStartTime, maxValue: maxValue, minValue: minValue, "data-selector-id": `${this.dataSelectorId}-time-control` }),
            "min"));
    }
    getCellDataForDrawBackground(indexHour, indexDay, extStatus = null) {
        let isDrawnLink = false;
        let status;
        if (extStatus !== null) {
            status = extStatus;
        }
        else {
            const { selectedCells, tmpSelectedCells, isSelectMode, isSelectedDay, isSelectedHour, isActive, tmpActiveFirstSelectedCell, tmpActiveFirstSelectedCell: { status: tmpActiveFirstSelectedCellStatus } } = this.state;
            let isTmpNearSelectedCells = false;
            const isSelected = indexHour !== -1 &&
                indexDay !== -1 &&
                selectedCells &&
                Object.prototype.hasOwnProperty.call(selectedCells, indexDay) &&
                selectedCells[indexDay].includes(indexHour);
            const isTmpSelectedCells = tmpSelectedCells &&
                Object.prototype.hasOwnProperty.call(tmpSelectedCells, indexDay) &&
                tmpSelectedCells[indexDay].includes(indexHour);
            if (!isSelectedHour &&
                indexHour === -1 &&
                tmpSelectedCells &&
                Object.prototype.hasOwnProperty.call(tmpSelectedCells, indexDay)) {
                isTmpNearSelectedCells = true;
                if (this.format === types_1.BACKUP_MATRIX_FORMAT.us) {
                    if (indexDay === 5) {
                        isDrawnLink = false;
                    }
                    else if (indexDay < 5) {
                        isDrawnLink = Object.prototype.hasOwnProperty.call(tmpSelectedCells, indexDay + 1);
                    }
                    else {
                        isDrawnLink = Object.prototype.hasOwnProperty.call(tmpSelectedCells, 0);
                    }
                }
                else {
                    // if is BACKUP_MATRIX_FORMAT.eu'
                    isDrawnLink = Object.prototype.hasOwnProperty.call(tmpSelectedCells, indexDay + 1);
                }
            }
            else if (!isSelectedDay && indexDay === -1 && tmpSelectedCells) {
                for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek += 1) {
                    if (Object.prototype.hasOwnProperty.call(tmpSelectedCells, dayOfWeek) &&
                        tmpSelectedCells[dayOfWeek].includes(indexHour)) {
                        isTmpNearSelectedCells = true;
                    }
                    if (Object.prototype.hasOwnProperty.call(tmpSelectedCells, dayOfWeek) &&
                        tmpSelectedCells[dayOfWeek].includes(indexHour + 1)) {
                        isDrawnLink = true;
                    }
                    if (isTmpNearSelectedCells || isDrawnLink) {
                        break;
                    }
                }
            }
            if (isTmpNearSelectedCells) {
                status = isSelectMode ? constants_1.STATUS_CELL.SELECT_HOVER : constants_1.STATUS_CELL.UNSELECT_HOVER;
            }
            else if (isTmpSelectedCells) {
                if (isActive &&
                    Object.prototype.hasOwnProperty.call(tmpActiveFirstSelectedCell, 'status') &&
                    (isSelectedDay || isSelectedHour)) {
                    status = tmpActiveFirstSelectedCellStatus;
                }
                else if (isSelectMode) {
                    status = isSelected ? constants_1.STATUS_CELL.SELECTED : constants_1.STATUS_CELL.SELECT_HOVER;
                }
                else {
                    status = !isSelected ? constants_1.STATUS_CELL.UNSELECTED : constants_1.STATUS_CELL.UNSELECT_HOVER;
                }
            }
            else if (indexHour === -1 || indexDay === -1) {
                status = constants_1.STATUS_CELL.DISABLED;
            }
            else if (isSelected) {
                status = constants_1.STATUS_CELL.SELECTED;
            }
            else {
                status = constants_1.STATUS_CELL.UNSELECTED;
            }
        }
        return {
            status,
            isDrawnLink
        };
    }
    getDataOfSelectElements(isProcessSelect, tmpEditedState) {
        const tmpEditedStateCopy = tmpEditedState;
        const { selectedCells, startPosition: { indexHour: startPositionIndexHour, indexDay: startPositionIndexDay }, endPosition: { indexHour: endPositionIndexHour, indexDay: endPositionIndexDay }, hoverPosition: { indexHour: hoverPositionIndexHour, indexDay: hoverPositionIndexDay } } = tmpEditedStateCopy;
        let resultSelectedCells = {};
        if (startPositionIndexHour === -1 && endPositionIndexHour !== startPositionIndexHour) {
            const DataOfSelectCells = (0, lib_for_Matrix_1.getDataOfSelectFromDayCaptionToOtherHour)(this.format, isProcessSelect, tmpEditedStateCopy);
            tmpEditedStateCopy.isSelectedDay = DataOfSelectCells.isSelectedDay;
            resultSelectedCells = DataOfSelectCells.selectedCells;
        }
        else if (startPositionIndexHour === -1 && startPositionIndexDay === endPositionIndexDay) {
            // select day
            const DataOfSelectCells = (0, lib_for_Matrix_1.getDataOfSelectDayCaption)(isProcessSelect, tmpEditedStateCopy);
            tmpEditedStateCopy.isSelectedDay = DataOfSelectCells.isSelectedDay;
            tmpEditedStateCopy.tmpActiveFirstSelectedCell =
                DataOfSelectCells.tmpActiveFirstSelectedCell;
            resultSelectedCells = DataOfSelectCells.selectedCells;
        }
        else if (startPositionIndexDay === -1 && endPositionIndexDay !== startPositionIndexDay) {
            const DataOfSelectCells = (0, lib_for_Matrix_1.getDataOfSelectFromHourCaptionToOtherDay)(this.format, isProcessSelect, tmpEditedStateCopy);
            tmpEditedStateCopy.isSelectedHour = DataOfSelectCells.isSelectedHour;
            resultSelectedCells = DataOfSelectCells.selectedCells;
        }
        else if (startPositionIndexDay === -1 &&
            startPositionIndexHour === endPositionIndexHour) {
            // select hour
            const DataOfSelectCells = (0, lib_for_Matrix_1.getDataOfSelectHourCaption)(isProcessSelect, tmpEditedStateCopy);
            tmpEditedStateCopy.isSelectedHour = DataOfSelectCells.isSelectedHour;
            tmpEditedStateCopy.tmpActiveFirstSelectedCell =
                DataOfSelectCells.tmpActiveFirstSelectedCell;
            resultSelectedCells = DataOfSelectCells.selectedCells;
        }
        else if (startPositionIndexHour !== -1 && startPositionIndexDay !== -1) {
            // select area on matrix cells
            const DataOfSelectCells = (0, lib_for_Matrix_1.getDataOfSelectFromMainCell)(this.format, isProcessSelect, tmpEditedStateCopy);
            tmpEditedStateCopy.isSelectedDay = DataOfSelectCells.isSelectedDay;
            tmpEditedStateCopy.tmpActiveFirstSelectedCell =
                DataOfSelectCells.tmpActiveFirstSelectedCell;
            resultSelectedCells = DataOfSelectCells.selectedCells;
        }
        else {
            resultSelectedCells = isProcessSelect ? {} : selectedCells;
        }
        const { tmpActiveFirstSelectedCell: { indexHour: tmpActiveFirstSelectedCellIndexHour, indexDay: tmpActiveFirstSelectedCellIndexDay } } = tmpEditedStateCopy;
        if (tmpActiveFirstSelectedCellIndexHour !== hoverPositionIndexHour ||
            tmpActiveFirstSelectedCellIndexDay !== hoverPositionIndexDay) {
            tmpEditedStateCopy.tmpActiveFirstSelectedCell = {};
        }
        return {
            tmpEditedStateCopy,
            resultSelectedCells
        };
    }
    getDataOfHoverElement(isProcessSelect, tmpEditedState) {
        var _a;
        const tmpEditedStateCopy = tmpEditedState;
        const { hoverPosition: { indexHour: hoverPositionIndexHour, indexDay: hoverPositionIndexDay } } = tmpEditedStateCopy;
        let resultSelectedCells = {};
        if (hoverPositionIndexHour === -1) {
            // hover day caption
            const DataOfSelectCells = (0, lib_for_Matrix_1.getDataOfHoverDayCaption)(isProcessSelect, tmpEditedStateCopy);
            resultSelectedCells = DataOfSelectCells.selectedCells;
        }
        else if (hoverPositionIndexDay === -1) {
            // hover hour caption
            const DataOfSelectCells = (0, lib_for_Matrix_1.getDataOfHoverHourCaption)(((_a = this.props.cursor) === null || _a === void 0 ? void 0 : _a.event) || types_1.CURSOR_EVENT.null, this.format, isProcessSelect, tmpEditedStateCopy);
            resultSelectedCells = DataOfSelectCells.selectedCells;
        }
        else if (hoverPositionIndexHour >= 0 && hoverPositionIndexDay >= 0) {
            const DataOfSelectCells = (0, lib_for_Matrix_1.getDataOfHoverMainCell)(isProcessSelect, tmpEditedStateCopy);
            resultSelectedCells = DataOfSelectCells.selectedCells;
        }
        return {
            resultSelectedCells
        };
    }
    parseAndUpdateState(isProcessSelect, tmpEditedState) {
        const tmpEditedStateCopy = JSON.parse(JSON.stringify(tmpEditedState));
        const { tmpActiveFirstSelectedCell: { indexHour: tmpActiveFirstSelectedCellIndexHour, indexDay: tmpActiveFirstSelectedCellIndexDay }, startPosition, endPosition, hoverPosition: { indexHour: hoverPositionIndexHour, indexDay: hoverPositionIndexDay } } = tmpEditedStateCopy;
        if (startPosition.indexHour !== undefined &&
            startPosition.indexDay !== undefined &&
            endPosition.indexHour !== undefined &&
            endPosition.indexDay !== undefined) {
            const { tmpEditedStateCopy: tmpSecondEditedStateCopy, resultSelectedCells } = this.getDataOfSelectElements(isProcessSelect, Object.assign(Object.assign({}, tmpEditedState), { startPosition: {
                    indexHour: startPosition.indexHour,
                    indexDay: startPosition.indexDay
                }, endPosition: {
                    indexHour: endPosition.indexHour,
                    indexDay: endPosition.indexDay
                } }));
            if (isProcessSelect) {
                this.setState(Object.assign(Object.assign(Object.assign({}, tmpEditedStateCopy), tmpSecondEditedStateCopy), { tmpSelectedCells: resultSelectedCells }));
            }
            else {
                this.setState(Object.assign(Object.assign(Object.assign({}, tmpEditedStateCopy), tmpSecondEditedStateCopy), { tmpSelectedCells: {}, selectedCells: resultSelectedCells, startPosition: {}, endPosition: {}, isSelectedHour: false, isSelectedDay: false, isActive: false }), this.callPropsOnChange);
            }
        }
        else if (isProcessSelect &&
            hoverPositionIndexHour !== undefined &&
            hoverPositionIndexDay !== undefined) {
            const dataOfSelectElements = this.getDataOfHoverElement(isProcessSelect, tmpEditedState);
            if (tmpActiveFirstSelectedCellIndexHour !== hoverPositionIndexHour ||
                tmpActiveFirstSelectedCellIndexDay !== hoverPositionIndexDay) {
                tmpEditedStateCopy.tmpActiveFirstSelectedCell = {};
            }
            this.setState(Object.assign(Object.assign({}, tmpEditedStateCopy), { tmpSelectedCells: dataOfSelectElements.resultSelectedCells, isSelectedHour: hoverPositionIndexDay === -1, isSelectedDay: hoverPositionIndexHour === -1 }));
        }
        else if (!isProcessSelect) {
            if (tmpActiveFirstSelectedCellIndexHour !== hoverPositionIndexHour ||
                tmpActiveFirstSelectedCellIndexDay !== hoverPositionIndexDay) {
                tmpEditedStateCopy.tmpActiveFirstSelectedCell = {};
            }
            this.setState(Object.assign(Object.assign({}, tmpEditedStateCopy), { startPosition: {}, endPosition: {} }));
        }
    }
    callPropsOnChange() {
        const { onChange } = this.props;
        const { selectedCells: cells, valueTime: time } = this.state;
        onChange === null || onChange === void 0 ? void 0 : onChange({ cells, time });
    }
    render() {
        const renderDescriptionOverLeftTopCaptionCell = getRenderDescriptionOverLeftTopCaptionCell();
        const renderDescriptionOverMainCells = getRenderDescriptionOverMainCells();
        const renderLeftTopCaptionCell = this.getRenderLeftTopCaptionCell();
        const renderDayCaptionCells = this.getRenderAllDayCaptionCells();
        const renderHourCaptionCells = this.getRenderAllHourCaptionCells();
        const renderMainCells = this.getRenderAllMainCells();
        const renderSelectOptionCaptionCell = getRenderSelectOptionCaptionCell();
        const renderSelectOptionElements = this.getRenderSelectOptionElements();
        const renderTimeOptionCaptionCell = getRenderTimeOptionCaptionCell();
        const renderTimeOptionElements = this.getRenderTimeOptionElements();
        return (react_1.default.createElement(Matrix_styles_1.StyledMatrix, { ref: this.domNodeRef, "data-selector-id": this.props['data-selector-id'] || 'matrix' },
            react_1.default.createElement(Matrix_styles_1.StyledMatrixRow, null,
                react_1.default.createElement(Matrix_styles_1.StyledMatrixCol, null,
                    renderDescriptionOverLeftTopCaptionCell,
                    renderLeftTopCaptionCell,
                    renderDayCaptionCells,
                    renderSelectOptionCaptionCell,
                    renderTimeOptionCaptionCell),
                react_1.default.createElement(Matrix_styles_1.StyledMatrixCol, null,
                    renderDescriptionOverMainCells,
                    renderHourCaptionCells,
                    renderMainCells,
                    renderSelectOptionElements,
                    renderTimeOptionElements))));
    }
};
//# sourceMappingURL=Matrix.js.map